var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 102C79.1665 102 102 79.1665 102 51C102 22.8335 79.1665 0 50.9999 0C22.8335 0 0 22.8335 0 51C0 79.1665 22.8335 102 50.9999 102Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_995_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9839 34.5481C72.787 34.5481 69.9143 33.4569 68.9567 33.0933C63.9295 30.7896 55.6705 24 51.122 24C46.5737 24 38.3147 30.6683 33.2875 33.0933C32.4496 33.4569 29.4571 34.5481 28.2603 34.5481C26.3451 34.6694 24.9087 36.3668 25.1482 38.1854C25.6269 42.6714 26.8239 50.6733 29.936 60.9791C34.0056 73.7095 45.257 81.3478 49.566 83.8938C50.6433 84.5001 51.8403 84.5001 52.9175 83.8938C57.2266 81.3478 68.4779 73.7095 72.3081 60.9791C75.4202 50.6733 76.6172 42.6714 77.096 38.1854C77.3354 36.3668 75.8991 34.6694 73.9839 34.5481Z",
    fill: "url(#paint0_linear_995_1436)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4284 39.0361C71.9496 42.6734 70.992 48.8567 68.8376 56.6163C68.5982 57.5862 68.2391 58.6774 67.88 59.6473C64.6482 70.1955 55.5513 76.8638 51.1226 79.5312C50.6439 79.2886 50.165 78.9249 49.6863 78.5611C45.0181 75.4088 37.3577 69.1042 34.485 59.6473C31.732 50.5541 30.535 43.1584 29.9365 39.0361C32.091 38.5512 34.7243 37.5811 35.2031 37.3387C37.2379 36.3688 39.5122 35.0351 41.9061 33.4589C44.5393 31.7615 49.4469 28.7305 51.1226 28.7305C52.7984 28.7305 57.7059 31.8828 60.3392 33.4589C62.7331 34.9138 65.0074 36.3688 67.0421 37.3387C67.6406 37.4599 70.2739 38.5512 72.4284 39.0361Z",
    fill: "url(#paint1_linear_995_1436)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8344 56.4884C68.595 57.4583 68.236 58.5494 67.8769 59.5195C64.645 70.0675 55.5483 76.7359 51.1194 79.4032C50.6407 79.1607 50.1619 78.7971 49.6831 78.4333L40.8257 53.2148L45.015 52.4874L50.2816 56.3672L61.6527 48.1226L65.2435 46.9102C65.2435 47.0314 66.7996 51.2749 68.8344 56.4884Z",
    fill: "url(#paint2_linear_995_1436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4896 61.5888L41.3079 54.3142C40.829 53.8293 40.829 52.8592 41.3079 52.3744L44.1806 49.4645C44.6593 48.9795 45.6168 48.9795 46.0957 49.4645L49.4472 52.8592C49.9259 53.3443 50.6441 53.3443 51.0031 52.8592L59.9803 43.766C60.4592 43.2811 61.4166 43.2811 61.8955 43.766L64.7681 46.6759C65.247 47.1609 65.247 48.1308 64.7681 48.6158L52.0804 61.5888C51.0031 62.5587 49.4472 62.5587 48.4896 61.5888Z",
    fill: "url(#paint3_linear_995_1436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_995_1436",
    x: 13.6444,
    y: 19.6959,
    width: 74.9553,
    height: 83.3029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.17352
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.73882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_995_1436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_995_1436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_995_1436",
    x1: 48.2787,
    y1: 42.6955,
    x2: 65.4266,
    y2: 66.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_995_1436",
    x1: 66.6232,
    y1: 67.8071,
    x2: 40.8189,
    y2: 35.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_995_1436",
    x1: 50.9941,
    y1: 52.1357,
    x2: 58.7207,
    y2: 64.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_995_1436",
    x1: 57.569,
    y1: 55.2466,
    x2: 50.2906,
    y2: 47.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f8b11e16591c19f6eb0e0f6c71997620.svg";
export { ForwardRef as ReactComponent };